module.exports = __webpack_public_path__ + "img/E6E3E3_B5AFAF_CCC4C4_C4C4C4-256px.9673e278.png";